<template>
  <v-main>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      :fetcher="fetchData"
    >
      <!-- Customiza a mensagem se não temos CCs selecionados -->
      <template v-slot:when-empty="{ filter, loadStatus }">
        <OJumbo
          info
          v-if="filter.technicianIds == null || filter.technicianIds.length < 1"
        >
          Selecione ao menos um Autorizado para buscar.
        </OJumbo>

        <OJumbo loading v-else-if="loadStatus == 'not-loaded'">
          Carregando dados...
        </OJumbo>

        <OJumbo question v-else>
          Não foram encontrados dados para o filtro/período informados.
        </OJumbo>
      </template>

      <!-- Customiza o botão de export excel para não exigir
           datas (pois sempre existe o strMonth) mas exigir
           technicianIds -->
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn icon @click="checkDownload" title="Exportar para Excel">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import { go } from '@/models'
import moment from 'moment'
import { saveBlobAs } from 'oderon-vue/utils'
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'

export default {
  pageTitle: 'Medição Multiproduto - CC',
  components: {
    GenericReport
  },
  data() {
    return {
      reportSpec: {
        code: 'multiproductTechnicianReport',
        title: 'Medição Multiproduto - Autorizados',

        // apesar de termos um fetcher, esta apiBase é usada
        // para montar o botão de colunas visíveis
        apiBase: '/multiproduct/technician',

        filters: [
          {
            type: 'Technician',
            whenEmpty: 'Selecione autorizados...',
            emptyMeansAll: false,
            size: 'sm'
          },
          {
            type: 'DateRange'
          }
        ]
      }
    }
  },
  methods: {
    // Retorna os parâmetros para a API, mas não valida os obrigatórios.
    computeApiParams(filter) {
      let { technicianIds, vars } = filter
      if (technicianIds != null && technicianIds.length < 1)
        technicianIds = null

      // untilDate nunca é null (o DateRangePicker seta para hoje)
      let { fromDate, untilDate } = filter
      if (fromDate == null) fromDate = moment().startOf('month')

      // NB: Não envia limit e offset pois não queremos paginação
      let params = {
        technicianIds,
        vars,
        fromDate: moment(fromDate).format('YYYY-MM-DD'),
        untilDate: moment(untilDate).format('YYYY-MM-DD')
      }

      return params
    },

    async fetchData(apiParams) {
      const newParams = this.computeApiParams(apiParams)
      if (newParams.technicianIds == null) {
        return { count: 0, rows: [] }
      } else {
        return await go.get('/multiproduct/technician/grid', newParams)
      }
    },

    async checkDownload() {
      const filter = this.$refs.report.apiParams
      const newParams = this.computeApiParams(filter)
      if (newParams.technicianIds == null) {
        this.$info({
          message: `
            <p>Para baixar o arquivo Excel deste relatório,
            é necessário selecionar pelo menos um autorizado.</p>
          `
        })
      } else {
        const res = await go.download(
          '/multiproduct/technician/grid/download',
          newParams
        )
        saveBlobAs(res.blob, res.filename)
      }
    }
  }
}
</script>

<style></style>
